import React, { useEffect, useState } from "react";
import {
  DataGrid,
  GridColDef,
  GridToolbar,
} from "@mui/x-data-grid";
import axios from "axios";
import HOST_URL from "../../../utils/Url";
import Card from "@mui/material/Card";
import {
  Box,
  Button,
  Divider,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import Switch from "@mui/material/Switch";
import { useNavigate, useLocation } from "react-router-dom";
import Chip from "@mui/material/Chip";
import { useTranslation } from "react-i18next";
import Paper from "@mui/material/Paper";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import { toast } from "react-toastify";
import ToastApp from "../../../ToastApp";
import DeleteIcon from "@mui/icons-material/Delete";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import CircularProgress from "@mui/material/CircularProgress";
import api from "../../../utils/Url";
import dayjs from "dayjs";
import DownloadIcon from '@mui/icons-material/Download';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

interface MenuPermission {
  isAdd: boolean;
  isEdit: boolean;
  isPrint: boolean;
  isDel: boolean;
}

interface Notice {
  noticeID: number;
  notice: string;
  description: string;
  fromDate: string;
  toDate: string;
  noticeDate: string;
  noticeDoc: string;
  isActive: boolean;
  serialNo: number;
  id: number;
  formattedFromDate: string;
  formattedToDate: string;
  formattedNoticeDate: string;
}

export default function Notice() {
  const [notices, setNotices] = useState<Notice[]>([]);
  const [columns, setColumns] = useState<GridColDef[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [addPageShow, setAddPageShow] = useState(false);
  const [viewedNotice, setViewedNotice] = useState<{
    image: string,
    name: string,
    isPdf: boolean
  } | null>(null);
  const location = useLocation();
  const [permissionData, setPermissionData] = useState<MenuPermission>({
    isAdd: false,
    isEdit: false,
    isPrint: false,
    isDel: false,
  });

  let navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    const dataString = localStorage.getItem("userdata");
    if (dataString) {
      const data = JSON.parse(dataString);
      if (data && data.length > 0) {
        const userPermissionData = data[0]?.userPermission;
        if (userPermissionData && userPermissionData.length > 0) {
          const menudata = userPermissionData[0]?.parentMenu;
          for (let index = 0; index < menudata.length; index++) {
            const childMenudata = menudata[index]?.childMenu;
            const pathrow = childMenudata.find(
              (x: any) => x.path === location.pathname
            );
            if (pathrow) {
              setPermissionData(pathrow);
              fetchNoticesData();
            }
          }
        }
      }
    }
  }, [isLoading]);

  let ID: any = localStorage.getItem("useR_ID");
  if (ID !== null) {
    ID = ID.replace(/\D/g, '');
  } else {
    toast.error("User ID not Found");
  }

  const handleSwitchChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    value: any
  ) => {
    // console.log(value)
    const collectData = {
      noticeID: value.id || 0,
      notice: value.notice || "",
      description: value.description || "",
      fromDate: value.fromDate ? new Date(value.fromDate).toISOString().split('T')[0] : "",
      toDate: value.toDate ? new Date(value.toDate).toISOString().split('T')[0] : "",
      noticeLink: value.noticeLink || "",
     isActive: event.target.checked,
      sortOrder: value.sortOrder || 0,
      createdDt: value.createdDt || new Date().toISOString(),
      modifyDt: new Date().toISOString(),
      user_ID: -1,
      noticeDoc: value.noticeDoc || "",
      noticeDate: value.noticeDate || new Date().toISOString(),

      // ZoneID: value.id,
      // zoneName: value.zoneName,
      // zoneCode: value.zoneCode,
      // isActive: event.target.checked,
      // user_ID: -1,
      // sortOrder: 0,
    };
    api
      .post(`Notice/AddUpdateNoticeMaster`, collectData)
      .then((response) => {
        if (response.data.isSuccess) {
          toast.success(response.data.mesg);
          fetchNoticesData();
        } else {
          toast.error(response.data.mesg);
        }
      });
  };

  const routeChangeEdit = (row: any) => {
    let path = `/newsLetter/NoticeMasterEdit`;
    navigate(path, {
      state: row,
    });
  };

  const routeChangeAdd = () => {
    let path = `/newsLetter/NoticeMasterAdd`;
    navigate(path);
  };

  let delete_id = "";

  const accept = () => {
    const collectData = {
      noticeID: delete_id,
      user_ID: parseInt(ID),
    };
    api
      .delete(`Notice/DeleteNoticeMaster`, { data: collectData })
      .then((response) => {
        if (response.data.isSuccess) {
          toast.success(response.data.mesg);
        } else {
          toast.error(response.data.mesg);
        }
        fetchNoticesData();
      });
  };

  const reject = () => {
    toast.warn("Rejected: You have rejected", { autoClose: 3000 });
  };

  const handledeleteClick = (del_id: any) => {
    delete_id = del_id;
    confirmDialog({
      message: "Do you want to delete this record?",
      header: "Delete Confirmation",
      icon: "pi pi-info-circle",
      acceptClassName: "p=-button-danger",
      accept,
      reject,
    });
  };

  const handleNoticeLinkClick = async (noticeId: number, noticeName: string) => {
    try {
      setIsLoading(true);
      const collectData = {
        noticeID: noticeId,
        user_ID: parseInt(ID),
        isActive: true
      };
      const response = await api.post(
        `Notice/GetNoticeMaster`,
        collectData
      );

      if (response.data.isSuccess && response.data.data.length > 0) {
        const noticeData = response.data.data[0];
        if (noticeData.noticeDoc) {
          // Check if the document is a PDF (either by extension or base64 prefix)
          const isPdf = noticeData.noticeDoc.startsWith('data:application/pdf') ||
            noticeData.noticeDoc.toLowerCase().endsWith('.pdf');

          setViewedNotice({
            image: noticeData.noticeDoc,
            name: noticeName,
            isPdf: isPdf
          });
        } else {
          toast.warn("No document available for this notice");
        }
      } else {
        toast.error("Failed to fetch notice document");
      }
    } catch (error) {
      console.error("Error fetching notice document:", error);
      toast.error("Error fetching notice document");
    } finally {
      setIsLoading(false);
    }
  };

  const handleDownload = () => {
    if (viewedNotice) {
      const link = document.createElement('a');
      link.href = viewedNotice.image;
      link.download = viewedNotice.name + (viewedNotice.isPdf ? '.pdf' : '');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  const fetchNoticesData = async () => {
    try {
      const collectData = {
        noticeID: -1,
        user_ID: parseInt(ID),
       // isActive: false
      };
      const response = await api.post(
        `Notice/GetNoticeMaster`,
        collectData
      );
      const data = response.data.data;
      const noticesWithIds = data.map((notice: any, index: number) => ({
        ...notice,
        serialNo: index + 1,
        id: notice.noticeID,
        formattedFromDate: dayjs(notice.fromDate).format('DD/MM/YYYY'),
        formattedToDate: dayjs(notice.toDate).format('DD/MM/YYYY'),
        formattedNoticeDate: dayjs(notice.noticeDate).format('DD/MM/YYYY'),
      }));
      setNotices(noticesWithIds);
      setIsLoading(false);

      if (data.length > 0) {
        const columns: GridColDef[] = [
          {
            field: "actions",
            headerClassName: "MuiDataGrid-colCell",
            headerName: t("text.Action"),
            width: 150,
            renderCell: (params) => {
              return [
                <Stack
                  spacing={1}
                  direction="row"
                  sx={{ alignItems: "center", marginTop: "5px" }}
                >
                  {permissionData?.isEdit ? (
                    <EditIcon
                      style={{
                        fontSize: "20px",
                        color: "blue",
                        cursor: "pointer",
                      }}
                      className="cursor-pointer"
                      onClick={() => routeChangeEdit(params.row)}
                    />
                  ) : (
                    ""
                  )}
                  {permissionData?.isDel ? (
                    <DeleteIcon
                      style={{
                        fontSize: "20px",
                        color: "red",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        handledeleteClick(params.row.id);
                      }}
                    />
                  ) : (
                    ""
                  )}

                  <Switch
                    checked={Boolean(params.row.isActive)}
                    style={{
                      color: params.row.isActive ? "green" : "#FE0000",
                    }}
                    onChange={(value: any) =>
                      handleSwitchChange(value, params.row)
                    }
                    inputProps={{
                      "aria-label": "Toggle Switch",
                    }}
                  />
                </Stack>,
              ];
            },
          },
          {
            field: "notice",
            headerName: t("text.Notice"),
            flex: 1,
            headerClassName: "MuiDataGrid-colCell",
          },
          {
            field: "description",
            headerName: t("text.Description"),
            flex: 1,
            headerClassName: "MuiDataGrid-colCell",
          },
          {
            field: "formattedNoticeDate",
            headerName: t("text.NoticeDate"),
            flex: 1,
            headerClassName: "MuiDataGrid-colCell",
          },
          {
            field: "formattedFromDate",
            headerName: t("text.FromDate"),
            flex: 1,
            headerClassName: "MuiDataGrid-colCell",
          },
          {
            field: "formattedToDate",
            headerName: t("text.ToDate"),
            flex: 1,
            headerClassName: "MuiDataGrid-colCell",
          },
          {
            field: "noticeLink",
            headerName: t("text.NoticeLink"),
            flex: 1,
            headerClassName: "MuiDataGrid-colCell",
            renderCell: (params) => (
              <Button
                variant="text"
                color="primary"
                onClick={() => handleNoticeLinkClick(params.row.id, params.row.notice)}
              >
                {params.row.notice}
              </Button>
            ),
          },
          {
            field: "isActive",
            headerName: t("text.Status"),
            flex: 1,
            headerClassName: "MuiDataGrid-colCell",
            renderCell: (params) => [
              <Stack direction="row" spacing={1}>
                {params.row.isActive ? (
                  <Chip
                    label={t("text.Active")}
                    color="success"
                    style={{ fontSize: "14px" }}
                  />
                ) : (
                  <Chip
                    label={t("text.InActive")}
                    color="error"
                    style={{ fontSize: "14px" }}
                  />
                )}
              </Stack>,
            ],
          },
        ];
        setColumns(columns);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const adjustedColumns = columns.map((column) => ({
    ...column,
  }));

  return (
    <>
      <Card
        style={{
          width: "100%",
          backgroundColor: "#E9FDEE",
          marginTop: "3vh"
        }}
      >
        <Paper
          sx={{
            width: "100%",
            overflow: "hidden",
            "& .MuiDataGrid-colCell": {
              backgroundColor: "#2B4593",
              color: "#fff",
              fontSize: 17,
              fontWeight: 900
            },
          }}
          style={{ padding: "10px" }}
        >
          <ConfirmDialog />

          <Typography
            gutterBottom
            variant="h5"
            component="div"
            sx={{ padding: "20px" }}
            align="left"
          >
            {t("text.NoticeManagement")}
          </Typography>
          <Divider />

          <Box height={10} />

          <Stack direction="row" spacing={2} classes="my-2 mb-2">
            {permissionData?.isAdd == true && (
              <Button
                onClick={routeChangeAdd}
                variant="contained"
                endIcon={<AddCircleIcon />}
                size="large"
              >
                {t("text.add")}
              </Button>
            )}
          </Stack>

          {isLoading ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <CircularProgress />
            </div>
          ) : (
            <Box>
              <br />
              <div style={{ width: "100%", backgroundColor: "#FFFFFF" }}>
                <DataGrid
                  rows={notices}
                  columns={adjustedColumns}
                  autoHeight
                  slots={{
                    toolbar: GridToolbar,
                  }}
                  rowSpacingType="border"
                  pagination={true}
                  pageSizeOptions={[5, 10, 25, 50, 100].map((size) => ({
                    value: size,
                    label: `${size}`,
                  }))}
                  initialState={{
                    pagination: { paginationModel: { pageSize: 5 } },
                  }}
                  slotProps={{
                    toolbar: {
                      showQuickFilter: true,
                    },
                  }}
                />
              </div>
            </Box>
          )}
        </Paper>
      </Card>

      {/* Enhanced Document Viewer Modal */}
      {viewedNotice && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.8)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 9999,
          padding: '20px',
          boxSizing: 'border-box'
        }} onClick={() => setViewedNotice(null)}>
          <div style={{
            width: '100%',
            maxWidth: '90vw',
            height: '90vh',
            backgroundColor: 'white',
            borderRadius: '8px',
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden'
          }} onClick={e => e.stopPropagation()}>
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              padding: '16px',
              backgroundColor: '#f5f5f5',
              borderBottom: '1px solid #e0e0e0'
            }}>
              <Typography variant="h6" style={{ flex: 1, overflow: 'hidden', textOverflow: 'ellipsis' }}>
                {viewedNotice.name}
              </Typography>
              <div>
                <IconButton
                  color="primary"
                  onClick={handleDownload}
                  aria-label="download"
                  style={{ marginRight: '10px' }}
                >
                  <DownloadIcon />
                </IconButton>
                <IconButton
                  color="error"
                  onClick={() => setViewedNotice(null)}
                  aria-label="close"
                >
                  <CloseIcon />
                </IconButton>
              </div>
            </div>
            <div style={{
              flex: 1,
              overflow: 'auto',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              padding: '20px'
            }}>
              {viewedNotice.isPdf ? (
                <iframe
                  src={viewedNotice.image}
                  style={{
                    width: '100%',
                    height: '100%',
                    border: 'none'
                  }}
                  title={viewedNotice.name}
                />
              ) : (
                <img
                  src={viewedNotice.image}
                  alt={viewedNotice.name}
                  style={{
                    maxWidth: '100%',
                    maxHeight: '100%',
                    objectFit: 'contain'
                  }}
                />
              )}
            </div>
          </div>
        </div>
      )}

      <ToastApp />
    </>
  );
}
















// import React, { useEffect, useState } from "react";
// import {
//   DataGrid,
//   GridColDef,
//   GridToolbar,
// } from "@mui/x-data-grid";
// import axios from "axios";
// import HOST_URL from "../../../utils/Url";
// import Card from "@mui/material/Card";
// import {
//   Box,
//   Button,
//   Divider,
//   Stack,
//   TextField,
//   Typography,
// } from "@mui/material";
// import EditIcon from "@mui/icons-material/Edit";
// import Switch from "@mui/material/Switch";
// import { useNavigate, useLocation } from "react-router-dom";
// import Chip from "@mui/material/Chip";
// import { useTranslation } from "react-i18next";
// import Paper from "@mui/material/Paper";
// import AddCircleIcon from "@mui/icons-material/AddCircle";
// import { toast } from "react-toastify";
// import ToastApp from "../../../ToastApp";
// import DeleteIcon from "@mui/icons-material/Delete";
// import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
// import CircularProgress from "@mui/material/CircularProgress";
// import api from "../../../utils/Url";
// import dayjs from "dayjs";

// interface MenuPermission {
//   isAdd: boolean;
//   isEdit: boolean;
//   isPrint: boolean;
//   isDel: boolean;
// }

// export default function Notice() {
//   const [notices, setNotices] = useState([]);
//   const [columns, setColumns] = useState<any>([]);
//   const [isLoading, setIsLoading] = useState(true);
//   const [addPageShow, setAddPageShow] = useState(false);
//   const location = useLocation();
//   const [permissionData, setPermissionData] = useState<MenuPermission>({
//     isAdd: false,
//     isEdit: false,
//     isPrint: false,
//     isDel: false,
//   });

//   let navigate = useNavigate();
//   const { t } = useTranslation();

//   useEffect(() => {
//     const dataString = localStorage.getItem("userdata");
//     if (dataString) {
//       const data = JSON.parse(dataString);
//       if (data && data.length > 0) {
//         const userPermissionData = data[0]?.userPermission;
//         if (userPermissionData && userPermissionData.length > 0) {
//           const menudata = userPermissionData[0]?.parentMenu;
//           for (let index = 0; index < menudata.length; index++) {
//             const childMenudata = menudata[index]?.childMenu;
//             const pathrow = childMenudata.find(
//               (x: any) => x.path === location.pathname
//             );
//             if (pathrow) {
//               setPermissionData(pathrow);
//               fetchNoticesData();
//             }
//           }
//         }
//       }
//     }
//   }, [isLoading]);

//   let ID: any = localStorage.getItem("useR_ID");
//   if (ID !== null) {
//     ID = ID.replace(/\D/g, '');
//   } else {
//     toast.error("User ID not Found");
//   }

//   const routeChangeEdit = (row: any) => {
//     let path = `/newsLetter/NoticeMasterEdit`;
//     navigate(path, {
//       state: row,
//     });
//   };

//   const routeChangeAdd = () => {
//     let path = `/newsLetter/NoticeMasterAdd`;
//     navigate(path);
//   };

//   let delete_id = "";

//   const accept = () => {
//     const collectData = {
//       noticeID: delete_id,
//       user_ID: parseInt(ID),
//     };
//     api
//       .delete(`Notice/DeleteNoticeMaster`, { data: collectData })
//       .then((response) => {
//         if (response.data.isSuccess) {
//           toast.success(response.data.mesg);
//         } else {
//           toast.error(response.data.mesg);
//         }
//         fetchNoticesData();
//       });
//   };

//   const reject = () => {
//     toast.warn("Rejected: You have rejected", { autoClose: 3000 });
//   };

//   const handledeleteClick = (del_id: any) => {
//     delete_id = del_id;
//     confirmDialog({
//       message: "Do you want to delete this record?",
//       header: "Delete Confirmation",
//       icon: "pi pi-info-circle",
//       acceptClassName: "p=-button-danger",
//       accept,
//       reject,
//     });
//   };

//   const fetchNoticesData = async () => {
//     try {
//       const collectData = {
//         noticeID: -1,
//         user_ID: parseInt(ID),
//         isActive: true
//       };
//       const response = await api.post(
//         `Notice/GetNoticeMaster`,
//         collectData
//       );
//       const data = response.data.data;
//       const noticesWithIds = data.map((notice: any, index: number) => ({
//         ...notice,
//         serialNo: index + 1,
//         id: notice.noticeID,
//         formattedFromDate: dayjs(notice.fromDate).format('DD/MM/YYYY'),
//         formattedToDate: dayjs(notice.toDate).format('DD/MM/YYYY'),
//         formattedNoticeDate: dayjs(notice.noticeDate).format('DD/MM/YYYY'),
//       }));
//       setNotices(noticesWithIds);
//       setIsLoading(false);

//       if (data.length > 0) {
//         const columns: GridColDef[] = [
//           {
//             field: "actions",
//             headerClassName: "MuiDataGrid-colCell",
//             headerName: t("text.Action"),
//             width: 150,
//             renderCell: (params) => {
//               return [
//                 <Stack
//                   spacing={1}
//                   direction="row"
//                   sx={{ alignItems: "center", marginTop: "5px" }}
//                 >
//                   {permissionData?.isEdit ? (
//                     <EditIcon
//                       style={{
//                         fontSize: "20px",
//                         color: "blue",
//                         cursor: "pointer",
//                       }}
//                       className="cursor-pointer"
//                       onClick={() => routeChangeEdit(params.row)}
//                     />
//                   ) : (
//                     ""
//                   )}
//                   {permissionData?.isDel ? (
//                     <DeleteIcon
//                       style={{
//                         fontSize: "20px",
//                         color: "red",
//                         cursor: "pointer",
//                       }}
//                       onClick={() => {
//                         handledeleteClick(params.row.id);
//                       }}
//                     />
//                   ) : (
//                     ""
//                   )}
//                 </Stack>,
//               ];
//             },
//           },
//           // {
//           //   field: "serialNo",
//           //   headerName: t("text.SrNo"),
//           //   flex: 1,
//           //   headerClassName: "MuiDataGrid-colCell",
//           // },
//           {
//             field: "notice",
//             headerName: t("text.Notice"),
//             flex: 1,
//             headerClassName: "MuiDataGrid-colCell",
//           },
//           {
//             field: "description",
//             headerName: t("text.Description"),
//             flex: 1,
//             headerClassName: "MuiDataGrid-colCell",
//           },
//           {
//             field: "formattedNoticeDate",
//             headerName: t("text.NoticeDate"),
//             flex: 1,
//             headerClassName: "MuiDataGrid-colCell",
//           },
//           {
//             field: "formattedFromDate",
//             headerName: t("text.FromDate"),
//             flex: 1,
//             headerClassName: "MuiDataGrid-colCell",
//           },
//           {
//             field: "formattedToDate",
//             headerName: t("text.ToDate"),
//             flex: 1,
//             headerClassName: "MuiDataGrid-colCell",
//           },
//           {
//             field: "noticeLink",
//             headerName: t("text.NoticeLink"),
//             flex: 1,
//             headerClassName: "MuiDataGrid-colCell",
//             renderCell: (params) => (
//               <a href={params.value} target="_blank" rel="noopener noreferrer">
//                 {params.value}
//               </a>
//             ),
//           },
//           {
//             field: "isActive",
//             headerName: t("text.Status"),
//             flex: 1,
//             headerClassName: "MuiDataGrid-colCell",
//             renderCell: (params) => [
//               <Stack direction="row" spacing={1}>
//                 {params.row.isActive ? (
//                   <Chip
//                     label={t("text.Active")}
//                     color="success"
//                     style={{ fontSize: "14px" }}
//                   />
//                 ) : (
//                   <Chip
//                     label={t("text.InActive")}
//                     color="error"
//                     style={{ fontSize: "14px" }}
//                   />
//                 )}
//               </Stack>,
//             ],
//           },
//         ];
//         setColumns(columns as any);
//       }
//     } catch (error) {
//       console.error("Error fetching data:", error);
//     }
//   };

//   const adjustedColumns = columns.map((column: any) => ({
//     ...column,
//   }));

//   return (
//     <>
//       <Card
//         style={{
//           width: "100%",
//           backgroundColor: "#E9FDEE",
//           marginTop: "3vh"
//         }}
//       >
//         <Paper
//           sx={{
//             width: "100%",
//             overflow: "hidden",
//             "& .MuiDataGrid-colCell": {
//               backgroundColor: "#2B4593",
//               color: "#fff",
//               fontSize: 17,
//               fontWeight: 900
//             },
//           }}
//           style={{ padding: "10px" }}
//         >
//           <ConfirmDialog />

//           <Typography
//             gutterBottom
//             variant="h5"
//             component="div"
//             sx={{ padding: "20px" }}
//             align="left"
//           >
//             {t("text.NoticeManagement")}
//           </Typography>
//           <Divider />

//           <Box height={10} />

//           <Stack direction="row" spacing={2} classes="my-2 mb-2">
//             {permissionData?.isAdd == true && (
//               <Button
//                 onClick={routeChangeAdd}
//                 variant="contained"
//                 endIcon={<AddCircleIcon />}
//                 size="large"
//               >
//                 {t("text.add")}
//               </Button>
//             )}
//           </Stack>

//           {isLoading ? (
//             <div
//               style={{
//                 display: "flex",
//                 justifyContent: "center",
//                 alignItems: "center",
//               }}
//             >
//               <CircularProgress />
//             </div>
//           ) : (
//             <Box>
//               <br />
//               <div style={{ width: "100%", backgroundColor: "#FFFFFF" }}>
//                 <DataGrid
//                   rows={notices}
//                   columns={adjustedColumns}
//                   autoHeight
//                   slots={{
//                     toolbar: GridToolbar,
//                   }}
//                   rowSpacingType="border"
//                   pagination={true}
//                   pageSizeOptions={[5, 10, 25, 50, 100].map((size) => ({
//                     value: size,
//                     label: `${size}`,
//                   }))}
//                   initialState={{
//                     pagination: { paginationModel: { pageSize: 5 } },
//                   }}
//                   slotProps={{
//                     toolbar: {
//                       showQuickFilter: true,
//                     },
//                   }}
//                 />
//               </div>
//             </Box>
//           )}
//         </Paper>
//       </Card>
//       <ToastApp />
//     </>
//   );
// }